import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Screen, Tab, TabPanel, Tabs, Typography } from '@tempmee/react';
import { CenteredSpinner } from '~/commonComponents';
import { TabBadge } from '../TabBadge';
import { colors } from '@tempmee/tailwind';
import { BackButton } from '~/commonComponents';
import { getWorkerClassificationManagement } from '../../actions';
import { createLoadingSelector } from '../../api/selectors';
import { Colors } from '../../themes/colors';
import { ConfirmedWorkerType } from './ConfirmedWorkerType/ConfirmedWorkerType';
import { PendingRequests } from './PendingRequests/PendingRequests';
import { Unselected } from './Unselected/Unselected';
import { getInitialTab } from './utils';

const loadingSelector = createLoadingSelector(['GET_WORKER_CLASSIFICATION_MANAGEMENT']);

export function WorkerClassificationManagement() {
  const dispatch = useDispatch();
  const requests = useSelector((state) => state.user.workerClassificationManagement);
  const isLoading = useSelector((state) => loadingSelector(state));
  // Controlled: requests load asynchronously, so the active tab must re-sync
  // when getInitialTab(requests) changes after mount (legacy Tabs did this via
  // its own useEffect on initialTab; DS Tabs defaultValue only applies once).
  const [activeTab, setActiveTab] = useState('unselected');

  useEffect(() => {
    setActiveTab(getInitialTab(requests));
  }, [requests]);

  useEffect(() => {
    dispatch(getWorkerClassificationManagement());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Worker Type Management" />
      <Screen.Body>
        <Typography
          as="span"
          italic
          color={colors.neutral[500]}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 50,
            gap: 2,
          }}
        >
          For more information about what worker type is,
          <a
            href="https://lp.joingotu.com/workerclassification"
            target="_blank"
            rel="noreferrer"
            style={{
              fontFamily: 'Nunito',
              color: Colors.secondary_500,
              fontWeight: 700,
              textDecoration: 'none',
              fontStyle: 'normal',
            }}
          >
            Click here
          </a>
          .
        </Typography>

        {isLoading ? (
          <CenteredSpinner />
        ) : (
          <div style={{ width: '80%', alignSelf: 'center', marginBottom: 120 }}>
            <Tabs defaultValue="unselected" value={activeTab} onChange={setActiveTab}>
              <Tab
                value="unselected"
                label={
                  <>
                    Unselected <TabBadge count={requests?.unselected?.length || undefined} max={10} />
                  </>
                }
              />
              <Tab
                value="pending-requests"
                label={
                  <>
                    Pending Requests{' '}
                    <TabBadge count={requests?.pending?.length || undefined} max={10} />
                  </>
                }
              />
              <Tab value="confirmed" label="Confirmed Worker Type" />
              <TabPanel value="unselected" style={{ width: '100%' }}>
                <Unselected />
              </TabPanel>
              <TabPanel value="pending-requests" style={{ width: '100%' }}>
                <PendingRequests />
              </TabPanel>
              <TabPanel value="confirmed" style={{ width: '100%' }}>
                <ConfirmedWorkerType />
              </TabPanel>
            </Tabs>
          </div>
        )}
      </Screen.Body>
    </Screen>
  );
}
